import { computed } from "vue";

import { useReadinessEmployeeViewState } from "@/views/ReadinessEmployees/composables/useReadinessEmployeeViewState";
import { useReadinessEmployees } from "@/composables/readinessEmployees/useReadinessEmployees";
import { useEmployees } from "@/composables/employees/useEmployees";

export function useTableConfig() {
  const viewState = useReadinessEmployeeViewState();
  const employees = useEmployees();
  const employee = useReadinessEmployees();
  const accountID = JSON.parse(localStorage.getItem("currentAccountID"));

  const tableParams = computed(() => {
    return {
      headers: [
        {
          text: "Employee",
          sortable: true,
          value: "first_name",
          // No explicit width: under tableLayoutFixed this column absorbs the
          // remaining horizontal space, which keeps it the widest column while
          // the table fills 100% of its container.
        },
        {
          text: "Readiness",
          sortable: true,
          value: "readiness",
          width: "18%",
        },
        {
          text: "Primary",
          sortable: false,
          value: "primary",
          img: "icons/briefcase.svg",
          width: "18%",
        },
        {
          text: "Preparing for",
          sortable: false,
          value: "prepares",
          img: "icons/preparing.svg",
          centerField: true,
          width: "14%",
        },
        {
          text: "Exclude from Average",
          sortable: false,
          value: "average",
          width: "120px",
          wordBreak: true,
          centerField: true,
        },
        {
          text: "",
          sortable: false,
          value: "chatter",
          width: "70px",
        },
      ],
      columns: [
        {
          field: "",
          component: "EmployeeCard",
          props: (item) => ({
            class: "my-4",
            ...viewState.getEmployeeCardProps(item),
          }),
          events: (item) => ({
            "update:availability": async (availabilityValue) => {
              const payload = {
                employee: item,
                value: availabilityValue,
              };
              await employee.onUpdateAvailability({
                accountId: accountID,
                data: payload,
              });
              await employee.loadAllEmployees();
            },
          }),
        },
        {
          field: "",
          component: "EmployeeReadinessBar",
          props: (item) => ({
            class: "my-4",
            ...viewState.getEmployeeReadinessProps(item),
          }),
        },
        {
          field: "",
          component: "EmployeeReadinessBar1",
          props: (item) => ({
            class: "my-4",
            ...viewState.getEmployeePrimaryReadinessProps(item),
          }),
        },
        {
          field: "",
          component: "EmployeeReadinessBar2",
          props: (item) => ({
            class: "my-4",
            ...viewState.getEmployeePrepareReadinessProps(item),
          }),
        },
        {
          field: "",
          component: "SwitchButton",
          props: (item) => ({
            class: "my-4",
            ...viewState.getSwitcherProps(item),
          }),
          events: (item) => ({
            onChange: async (value) => {
              viewState.updateEmployeeExcludeFromAvgValue(item, value);
            },
          }),
        },
        {
          field: "",
          component: "ChatterButton",
          props: () => ({
            class: "my-4",
          }),
          events: (item) => ({
            onClick: () => {
              employees.setCurrentEmployee(item);
              viewState.openEmployeeChatterModal();
            },
          }),
        },
      ],
      filters: {
        values: viewState.state.filters.values,
        searchText: viewState.state.filters.searchText,
        // ER-10506 / MDP-552 (Rules Rule 5): readable applied-filter chips (Requires
        // Recalc / Excluded / Not Excluded) under the new filter bar; the legacy
        // SearchModal path keeps the historical raw-value chips.
        chipLabels: viewState.isReadinessFilterBarMdp552Enabled.value
          ? viewState.getFilterDisplayLabels(viewState.state.filters.values)
          : undefined,
      },
      hideTopSection: true,
      // ER-11425: render this table with a deterministic fixed layout so the
      // table fills its container and the columns honour the explicit widths
      // above (Employee absorbs the remaining space).
      tableLayoutFixed: true,
      hideActiveNo: false,
      activeRecords: {
        field: "status",
        value: "active",
      },
      actionLabel: "Recalculate All",
      showActionButton: true,
      must: viewState.state.filters.needsRecalculation ? true : false,
      hideGridView: true,
      hideButtonIcon: true,
      title: "Employees Readiness",
      hideButtonInMessage: true,
      getRowStyle: (item) => ({
        backgroundColor: item.primary_position?.status === "active" ? "#FFFFFF" : "#FFFFFF",
      }),
    };
  });
  return {
    tableParams,
  };
}
